export default "__VITE_ASSET__0b0122e9__"